module.exports = [{
      plugin: require('/usr/src/app/node_modules/gatsby-plugin-transition-link/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/usr/src/app/node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[],"maxWidth":800},
    },{
      plugin: require('/usr/src/app/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
